import React from "react";

const UserDetails = ({ selectedUser, handleCloseModal }) => {

  return (
    <>
      <div className="modal fade show d-block" tabIndex="-1" style={{zIndex:"9999"}} >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">
                User Details
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={handleCloseModal}
              ></button>
            </div>

            <div className="modal-body">
              <div className="row ">
                <div className="col-md-6">
                  <strong>Name:</strong>
                  <p>
                    {selectedUser.first_name} {selectedUser.last_name}
                  </p>
                  <hr />
                </div>

                <div className="col-md-6">
                  <strong>Email:</strong>
                  <p>{selectedUser.email}</p>
                  <hr />

                </div>

                <div className="col-md-6">
                  <strong>Mobile:</strong>
                  <p>{selectedUser.mobile_no || "-"}</p>
                  <hr />
                </div>

                <div className="col-md-6">
                  <strong>Role:</strong>
                  <p className="text-capitalize">{selectedUser.role}</p>
                  <hr />
                </div>

           {selectedUser.street_no && (
             <div className="col-md-6">
               <strong>Street No:</strong>
               <p>{selectedUser.street_no}</p>
               <hr />
             </div>
           )}

           {selectedUser.street_name && (
             <div className="col-md-6">
               <strong>Street Name:</strong>
               <p>{selectedUser.street_name}</p>
               <hr />
             </div>
           )}

                <div className="col-md-6">
                  <strong>City:</strong>
                  <p>{selectedUser.city || "-"}</p>
                  <hr />

                </div>

                 {selectedUser.province && (
                   <div className="col-md-6">
                     <strong>Province:</strong>
                     <p>{selectedUser.province}</p>
                     <hr />

                   </div>
                 )}

                <div className="col-md-6">
                  <strong>Address:</strong>
                  <p>{selectedUser.address || "-"}</p>
                  <hr />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                className="btn btn-secondary"
                onClick={handleCloseModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .modal.show {
          background-color: rgba(0, 0, 0, 0.5);
        }
      `}</style>
    </>
  );
};

export default UserDetails;
